"use client";
import EducationTimeline from "@/components/ui/EducationTimeline";
import ExperienceTimeline from "@/components/ui/ExperienceTimeline";
import Skills from "@/components/ui/Skills";
import { motion } from "framer-motion";

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

function Resume() {
    return (
        <motion.section
            className="p-2"
            initial="hidden"
            whileInView="visible"
            variants={containerVariants}
        >
            <motion.h2
                className="text-3xl font-bold text-primary lg:text-4xl"
                variants={sectionVariants}
            >
                Resume
            </motion.h2>
            <motion.div variants={sectionVariants}>
                <ExperienceTimeline />
            </motion.div>
            <motion.div variants={sectionVariants}>
                <EducationTimeline />
            </motion.div>
            <motion.div variants={sectionVariants}>
                <Skills />
            </motion.div>
        </motion.section>
    );
}

export default Resume;
